/* Hike gedragsmeting op de productpagina (behavior-analytics/README.md).
   Meet per paginabezoek: tijd (totaal, zichtbaar, actief), scrollbereik, tijd per
   sectie, geopende accordeons/FAQ, keuzes, klikvakken, winkelmand en laadtijd.
   Geen cookies; sessionStorage alleen bij analytics-toestemming van Shopify.
   Geen formulierinhoud, geen URL's, geen tekst van de pagina. Faalt stil. */
(function () {
  'use strict';
  var me = document.currentScript;
  if (!me || !window.IntersectionObserver || !navigator.sendBeacon || !window.JSON) return;
  var END = me.getAttribute('data-endpoint'), PID = me.getAttribute('data-product') || '';
  var VER = (me.getAttribute('data-v') || 'pdp1').toLowerCase();
  if (!END || !/^\d{5,20}$/.test(PID)) return;
  if (navigator.webdriver || /bot|crawl|spider|headless|lighthouse|pingdom|preview/i.test(navigator.userAgent)) return;
  if (/preview_theme_id|oseid|design_mode/.test(location.search) || (window.Shopify && Shopify.designMode)) VER += '-preview';

  var P = window.performance, now = function () { return P.now(); };
  var cost = 0, t0 = now();
  var MAXMS = 1800000, SEQMAX = 60;

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = crypto.getRandomValues(new Uint8Array(16)), h = [];
    b[6] = b[6] & 15 | 64; b[8] = b[8] & 63 | 128;
    for (var i = 0; i < 16; i++) h.push((b[i] + 256).toString(16).slice(1));
    return h.slice(0, 4).join('') + '-' + h.slice(4, 6).join('') + '-' + h.slice(6, 8).join('') + '-' + h.slice(8, 10).join('') + '-' + h.slice(10).join('');
  }
  function consented() {
    try { var c = window.Shopify && Shopify.customerPrivacy; return !!(c && c.analyticsProcessingAllowed && c.analyticsProcessingAllowed()); } catch (e) { return false; }
  }
  var pageId = uuid(), sessionId = pageId, linked = false;
  if (consented()) {
    try { sessionId = sessionStorage.getItem('ha_bsid') || uuid(); sessionStorage.setItem('ha_bsid', sessionId); linked = true; } catch (e) {}
  }

  function source() {
    var q = new URLSearchParams(location.search), m = (q.get('utm_medium') || '').toLowerCase(),
        s = (q.get('utm_source') || '').toLowerCase(), h = '';
    try { h = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid') || (/google/.test(s) && /cpc|ppc|paid|shopping/.test(m))) return 'google_paid';
    if (q.get('msclkid')) return 'bing_paid';
    if (q.get('fbclid') || /facebook|instagram|meta|^fb$|^ig$/.test(s)) return /cpc|paid/.test(m) ? 'meta_paid' : 'social';
    if (/cpc|ppc|paid/.test(m)) return 'other_paid';
    if (/email|klaviyo/.test(m + ' ' + s)) return 'email';
    if (h) {
      if (h === location.hostname) return 'internal';
      if (/(^|\.)google\./.test(h)) return 'google';
      if (/(^|\.)bing\./.test(h)) return 'bing';
      if (/facebook|instagram|pinterest|tiktok|reddit|youtube|^t\.co$/.test(h)) return 'social';
      if (/mail|outlook|klaviyo/.test(h)) return 'email';
      return 'referral';
    }
    return 'direct';
  }
  var S = window.Shopify || {};
  var lang = String(S.locale || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var ctry = String(S.country || '').toUpperCase();
  var base = {
    v: 1, pageId: pageId, sessionId: sessionId, linked: linked, productId: PID,
    locale: (/^[a-z]{2}$/.test(lang) ? lang : 'xx') + '-' + (/^[A-Z]{2}$/.test(ctry) ? ctry : 'XX'),
    device: innerWidth < 768 ? 'mobile' : innerWidth < 1100 ? 'tablet' : 'desktop',
    source: source(), version: VER.replace(/[^a-z0-9_-]/g, '').slice(0, 40)
  };

  /* Secties: sleutel -> selector. Een sleutel mag meerdere elementen hebben. */
  var DEFS = [
    ['shelf', '.fam--pdp'], ['gallery', '.ha-gal'], ['title', '.ha-identity'], ['price', '.ha-buy .ha-price'],
    ['options', '.ha-buy [data-ha-opt]'], ['atc', '[data-ha-atc-wrap]'], ['trust', '.ha-pay,.ha-trust2,.ha-assure'],
    ['combo', '.ha-combo'], ['benefits', '[data-ha-whyacc]'], ['breakdown', '[data-ha-breakdown]'],
    ['wear', '[data-ha-wear]'], ['compare', '[data-ha-compare]'], ['problems', '[data-ha-probs]'],
    ['faq', '[data-ha-faq]'], ['final', '[data-ha-final]'], ['cyh', '[data-ha-cyh]'], ['sticky', '[data-ha-matc]'],
    ['footer', '.shopify-section-group-group-footer']
  ];
  var sec = {}, cover = new Map(), tracked = [], ev = {}, firsts = {}, choices = {}, clicks = {}, nClicks = 0;
  function S0(k) { return sec[k] || (sec[k] = { v: 0, a: 0, o: 0, els: [] }); }
  function add(map, k, cap) { if (map[k] || Object.keys(map).length < (cap || 100)) map[k] = Math.min((map[k] || 0) + 1, 500); }
  function hit(k) { add(ev, k); if (!(k in firsts) && Object.keys(firsts).length < 40) firsts[k] = Math.round(now()); }

  var TH = []; for (var i = 0; i <= 20; i++) TH.push(i / 20);
  var io = new IntersectionObserver(function (es) {
    var c = now();
    es.forEach(function (e) { cover.set(e.target, [e.isIntersecting ? e.intersectionRect.height : 0, e.boundingClientRect.height]); });
    cost += now() - c;
  }, { threshold: TH });
  function track(el, k) {
    if (!el || el.__habk) return;
    el.__habk = k; S0(k).els.push(el); tracked.push(el); io.observe(el);
  }
  function scan() {
    var c = now();
    DEFS.forEach(function (d) { document.querySelectorAll(d[1]).forEach(function (el) { track(el, d[0]); }); });
    document.querySelectorAll('.ha-acc details[data-ha-acc]').forEach(function (el, n) {
      var id = (el.getAttribute('data-ha-acc') || '').toLowerCase();
      track(el, 'acc_' + (/^[a-z0-9_]{1,16}$/.test(id) ? id : n + 1));
    });
    document.querySelectorAll('[data-ha-faq-box] details').forEach(function (el, n) { if (n < 30) track(el, 'faq_' + (n + 1)); });
    document.querySelectorAll('.ha-slide').forEach(function (el, n) { if (n < 30 && !el.__habs) { el.__habs = n + 1; slides.observe(el); } });
    cost += now() - c;
  }
  var slides = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.intersectionRatio >= 0.6) hit('slide_' + e.target.__habs); });
  }, { threshold: [0.6] });

  function inView(k) {
    var s = sec[k], seen = 0, tall = 0, vh = innerHeight || 1;
    for (var j = 0; j < s.els.length; j++) { var c = cover.get(s.els[j]); if (c) { seen += c[0]; tall += c[1]; } }
    return seen > 0 && seen >= Math.min(tall * 0.5, vh * 0.35);
  }

  /* Klok vanaf navigatiestart; telt alleen als de tab zichtbaar is; actief = invoer in de laatste 15 s.
     Het laden zelf telt als zichtbaar en actief als de tab toen al zichtbaar was. */
  var last = now(), lastInput = now(), maxScroll = 0;
  var visMs = document.visibilityState === 'visible' ? last : 0, actMs = visMs;
  function tick() {
    var c = now(), d = Math.min(c - last, 5000); last = c;
    if (document.visibilityState !== 'visible' || d <= 0) return;
    var act = c - lastInput < 15000;
    visMs += d; if (act) actMs += d;
    for (var k in sec) {
      if (!inView(k)) continue;
      var s = sec[k]; s.v += d; if (act) s.a += d;
      for (var j = 0; j < s.els.length; j++) if (s.els[j].open) { s.o += d; break; }
    }
    cost += now() - c;
  }
  function exitKey() {
    var best = '', most = 0;
    for (var k in sec) {
      if (k === 'sticky' || /^faq_/.test(k)) continue;
      var seen = 0; sec[k].els.forEach(function (el) { var c = cover.get(el); if (c) seen += c[0]; });
      if (seen > most) { most = seen; best = k; }
    }
    return best;
  }
  function onScroll() {
    lastInput = now();
    if (onScroll.q) return; onScroll.q = 1;
    setTimeout(function () {
      onScroll.q = 0; var c = now(), h = document.documentElement.scrollHeight || 1;
      maxScroll = Math.max(maxScroll, Math.min(100, Math.round(100 * (scrollY + innerHeight) / h)));
      cost += now() - c;
    }, 250);
  }
  function keyOf(el) { for (; el && el !== document; el = el.parentNode) if (el.__habk) return el; return null; }

  var burst = [], pending = 0, lastOk = -1e9, otherAt = -1e9;
  function onClick(e) {
    var c = now(); lastInput = c;
    var el = e.target; if (!el || !el.closest) return;
    var box = keyOf(el), k = box ? box.__habk : 'other';
    if (box && e.clientX + e.clientY > 0 && nClicks < 400) {
      var r = box.getBoundingClientRect(), cl = function (n) { return Math.max(0, Math.min(9, Math.floor(n))); };
      add(clicks, k + '@' + cl(10 * (e.clientX - r.left) / (r.width || 1)) + '_' + cl(10 * (e.clientY - r.top) / (r.height || 1))); nClicks++;
    }
    if (!el.closest('a,button,input,select,textarea,label,summary,[role=button],[onclick],[tabindex],[data-ha-go]')) hit('dead_' + k);
    burst.push([c, e.clientX, e.clientY]); burst = burst.filter(function (b) { return c - b[0] < 800 && Math.abs(b[1] - e.clientX) < 40 && Math.abs(b[2] - e.clientY) < 40; });
    if (burst.length === 3) hit('rage_' + k);
    var sm = el.closest('summary'), det = sm && sm.parentNode;
    if (det && det.__habk) hit((det.open ? 'close_' : 'open_') + det.__habk);
    if (el.closest('[data-ha-sizeguide]')) hit('size_guide');
    var opt = el.closest('[data-ha-val]');
    if (opt) {
      var box2 = opt.closest('[data-ha-opt]'), n = box2 ? box2.getAttribute('data-ha-opt') : '';
      var val = String(opt.getAttribute('data-ha-val') || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 24);
      if (/^[1-3]$/.test(n) && val) add(choices, 'o' + n + '_' + val, 40);
      hit(box2 && box2.querySelector('[data-ha-sizeguide]') ? 'size_choice' : opt.hasAttribute('data-ha-colour') ? 'color_choice' : 'option_choice');
    }
    if (el.closest('[data-ha-go],.ha-nav')) hit('gallery_nav');
    if (el.closest('.fam-c')) hit('shelf_click');
    if (el.closest('[data-ha-final-cta]')) hit('final_cta');
    if (el.closest('[data-ha-cyh] a,[data-ha-cyh] button')) hit('cyh_click');
    if (el.closest('[data-ha-matc] button')) hit('sticky_atc');
    var atc = document.querySelector('[data-ha-atc]');
    if (el.closest('[data-ha-atc-wrap]') && atc && atc.disabled) hit('atc_blocked');
    if (el.closest('a[href*="/checkout"],[name="checkout"]')) hit('checkout_click');
    cost += now() - c;
  }
  /* Hoofdformulier = het formulier met de variantkiezer; andere /cart/add (CYH, combo) apart. */
  function onSubmit(e) {
    var f = e.target, a = f && f.getAttribute && (f.getAttribute('action') || '');
    if (/\/cart\/add/.test(a)) {
      if (f.querySelector('[data-ha-variants]')) { hit('cart_attempt'); pending = now(); } else { hit('cart_add_other'); otherAt = now(); }
    } else if (/checkout/.test(a) || (e.submitter && e.submitter.name === 'checkout')) hit('checkout_click');
  }
  function cartDone(ok, fromNet) {
    var c = now();
    if (pending) { hit(ok ? 'cart_success' : 'cart_error'); pending = 0; if (ok) lastOk = c; }
    else if (fromNet && ok && c - lastOk > 5000 && c - otherAt > 5000) { hit('cart_add_other'); otherAt = c; }
  }

  /* Laadtijd van de pagina zelf, voor voor/na-vergelijking. */
  var vit = {}, cls = 0, inp = 0;
  function po(type, fn, opts) { try { new PerformanceObserver(function (l) { l.getEntries().forEach(fn); }).observe(Object.assign({ type: type, buffered: true }, opts || {})); } catch (e) {} }
  po('largest-contentful-paint', function (e) { vit.lcp = Math.round(e.startTime); });
  po('paint', function (e) { if (e.name === 'first-contentful-paint') vit.fcp = Math.round(e.startTime); });
  po('layout-shift', function (e) { if (!e.hadRecentInput) cls += e.value; });
  po('event', function (e) { if (e.interactionId && e.duration > inp) inp = e.duration; }, { durationThreshold: 40 });
  po('resource', function (e) {
    if (!/\/cart\/add/.test(e.name)) return;
    var st = e.responseStatus;
    if (st >= 400) cartDone(false, 1); else if (st >= 200) cartDone(true, 1);
  });
  document.addEventListener('theme:cart:change', function () { if (pending) cartDone(true); });

  var seq = 0, stopped = false, lastJson = '';
  function send() {
    if (stopped) return;
    var c = now(); tick();
    var el = Math.round(c);
    if (el > MAXMS || seq >= SEQMAX) { stopped = true; return; }
    if (pending && c - pending > 15000) { hit('cart_nosuccess'); pending = 0; }
    var nav = P.getEntriesByType && P.getEntriesByType('navigation')[0];
    if (nav) vit.ttfb = Math.round(nav.responseStart);
    vit.cls = Math.round(cls * 1000); if (inp) vit.inp = Math.round(inp);
    var sections = {};
    for (var k in sec) if (sec[k].v) sections[k] = { v: Math.round(sec[k].v), a: Math.round(sec[k].a), o: Math.round(sec[k].o) };
    var body = {
      elapsedMs: el, visibleMs: Math.round(visMs), activeMs: Math.round(actMs), scroll: maxScroll, exit: exitKey(),
      sections: sections, events: ev, firsts: firsts, choices: choices, clicks: clicks, vitals: vit
    };
    var sig = JSON.stringify(body).replace(/"elapsedMs":\d+,/, '');
    if (sig === lastJson) { cost += now() - c; return; }
    lastJson = sig; seq++;
    body.seq = seq; body.costMs = Math.round(cost + now() - c);
    for (var b in base) body[b] = base[b];
    try { navigator.sendBeacon(END, new Blob([JSON.stringify(body)], { type: 'text/plain' })); } catch (e) {}
    cost += now() - c;
  }

  function start() {
    var c = now();
    scan(); setTimeout(scan, 1500); setTimeout(scan, 5000);
    setInterval(tick, 1000);
    [10000, 45000, 120000].forEach(function (t) { setTimeout(send, t); });
    setInterval(send, 300000);
    addEventListener('scroll', onScroll, { passive: true });
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) { addEventListener(t, function () { lastInput = now(); }, { passive: true, capture: true }); });
    var mm = 0; addEventListener('mousemove', function () { var c2 = now(); if (c2 - mm > 1000) { mm = c2; lastInput = c2; } }, { passive: true });
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    addEventListener('error', function () { hit('js_error'); });
    addEventListener('unhandledrejection', function () { hit('js_reject'); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') send(); else last = now();
    });
    addEventListener('pagehide', send);
    onScroll();
    cost += now() - c;
  }
  if (window.requestIdleCallback) requestIdleCallback(start, { timeout: 2000 }); else setTimeout(start, 200);
  cost += now() - t0;
})();
